

export default {
  components: {
    // eslint-disable-next-line vue/no-reserved-component-names
    Time: () => import(/* webpackChunkName: "TimePickerScroll" */ './TimePickerScroll')
  },
  props: ['value', 'field'],
  computed: {
    advancedOptionListResponsiveView () { return this.$store.state.store.advancedOptionListResponsiveView }
  }
}
